import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as AgoraRTC from 'agora-rtc-sdk';
import 'hammerjs';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

if (environment.production) {
  enableProdMode();
  AgoraRTC.Logger.setLogLevel(0);
  console.log = () => {};
}

if (!firebase.apps.length) {
  firebase.initializeApp(environment.firebase);
  
  if (environment.firebaseEmulator?.enabled) {
    const emulatorConfig = environment.firebaseEmulator;
    
    if (emulatorConfig.firestore) {
      firebase.firestore().settings({
        host: `${emulatorConfig.firestore.host}:${emulatorConfig.firestore.port}`,
        ssl: false,
      });
      console.log(`Firestore emulator configured: ${emulatorConfig.firestore.host}:${emulatorConfig.firestore.port}`);
    }
    
    if (emulatorConfig.auth) {
      const auth = firebase.auth();
      if (typeof (auth as any).useEmulator === 'function') {
        (auth as any).useEmulator(`http://${emulatorConfig.auth.host}:${emulatorConfig.auth.port}`);
        console.log(`Auth emulator configured: ${emulatorConfig.auth.host}:${emulatorConfig.auth.port}`);
      } else {
        console.warn('Auth emulator not supported in Firebase 7.x. Consider upgrading to Firebase 8+ for emulator support.');
      }
    }
    
    if (emulatorConfig.storage) {
      const storage = firebase.storage();
      if (typeof (storage as any).useEmulator === 'function') {
        (storage as any).useEmulator(emulatorConfig.storage.host, emulatorConfig.storage.port);
        console.log(`Storage emulator configured: ${emulatorConfig.storage.host}:${emulatorConfig.storage.port}`);
      } else {
        console.warn('Storage emulator not supported in Firebase 7.x. Consider upgrading to Firebase 8+ for emulator support.');
      }
    }
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
